// Module
var code = "<i ng-if=\"!componentForm\" class=\"fa fa-circle-o-notch fa-spin spinner\"></i> <kform-form form=\"componentForm\" name=\"'form-' + component.key\"></kform-form> ";
// Exports
export default code;